const basePath = `https://events.${process.env.robloxSiteDomain}`;
// eslint-disable-next-line import/prefer-default-export -- NOTE(@zwang, 04/30/24): expect to have more exports in this file
export const getUrl = () => basePath;
